<template>
  <div class="main-page">
    <header :class="`p-header ${currentBranding.headerClass}`">
        <nav class="nav-logo p-container">
            <img src="@/assets/images/logo/marholidays.png" class="logo" alt="The Fives Vacations" v-if="currentBranding.brandingCode == 'MHTN'" />
            <img src="@/assets/images/logo/epicTravelers.png" class="logo" alt="The Fives Vacations" v-else-if="currentBranding.brandingCode == 'EPIC'" />
            <img src="@/assets/images/logo/tfb.png" class="logo" alt="The Fives Vacations" v-else />
        </nav>
    </header>

    <div class="body-page">
      <b-container class="content-page">
        <b-row v-if="validPayResponse">
          <!-- 1ra columna -->

          <b-col class="col-md-6 col-sm-12 col-lg-6 col-xl-5 columna">
            <div v-if="dataOrderPay">
              <!-- Purchased Products -->
              <b-card tag="article" class="mb-2 rounded-0">
                <!-- Products -->
                <template #header>
                  <div class="col-md-12">
                    <h4 class="listPayTitle mb-0">
                      Purchased Products:
                      <strong>{{ dataOrderPay.detail.length }}</strong>
                    </h4>
                  </div>
                </template>
                <!-- Detail -->
                <table class="table animate__animated animate__bounce">
                  <tbody>
                    <tr v-for="item in dataOrderPay.detail" :key="item.uuid">
                      <td :class="`text-small-cart ${item.ref == detailId ? 'bg-gradient-success' : ''}`" v-if="!!item.booking" :id="'room' + item.booking.id">
                        <span>
                          <span style="font-weight: bold; font-size: 16px">
                            {{ item.booking.roomtypename }}
                          </span>
                          <div v-if="parseFloat(item.balance) == 0.0" class="text-center float-right">
                            <label><i>This booking is already paid</i></label>
                          </div>
                          <span v-else-if="item.partial == true && dataOrderPay.currencyPaid != 0">
                            <b-button v-if="item.ref != detailId" variant="primary" class="text-center float-right"
                              :disabled="manageEpayment || (!!detailId && item.ref != detailId)" size="sm" @click="sendPayBook(item)">
                              <feather-icon icon="CreditCardIcon" /> Pay this booking
                            </b-button>
                            <b-button v-else variant="danger" class="text-center float-right" :disabled="manageEpayment"
                              size="sm" @click="cancelPayBook(item)">
                              <feather-icon icon="XIcon" /> Cancel
                            </b-button>
                          </span>
                          <div class="text-center float-right" v-else-if="isloadingTransactions">
                            <b-spinner label="Loading..." small variant="success" />
                          </div>

                          <table class="content booking">
                            <tr></tr>
                            <tr>
                              <td>
                                <span style="font-weight: bold">Check-In:</span>
                                <span style="">{{ item.booking.dateIn }}</span>
                              </td>

                              <td>
                                <span style="font-weight: bold">Check-Out:</span>
                                <span style="">{{ item.booking.dateOut }}</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <span style="font-weight: bold">Nights:</span>
                                {{ item.booking.nights }}
                              </td>

                              <td>
                                <span style="font-weight: bold">Adults:</span>
                                {{ item.booking.adults }}
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <span style="font-weight: bold">Childrens:</span>
                                {{ item.booking.children }}
                              </td>
                            </tr>
                          </table>

                          <table class="content booking" v-if="item.booking.dateIn">
                            <tr>
                              <td>
                                <span style="font-weight: bold">Plan:</span>
                                {{ item.booking.rateplanname }}
                              </td>
                              <td>
                                <span style="font-weight: bold">Balance:</span>
                                {{ formatCurrency(item.currencyBalance) }} {{ dataOrderPay.currency }}
                              </td>
                            </tr>
                          </table>
                        </span>
                      </td>
                      <td v-else>
                        <span class="">
                          <span class="titleProduc" style="font-weight: bold">
                            {{ item.itemsold }}
                          </span>

                          <span class="display-inline" style="font-weight: bold">
                            Operation Date:
                          </span>

                          <span class="display-inline">
                            {{ item.operationdate }}
                          </span>
                        </span>
                      </td>
                    </tr>
                    <hr />
                  </tbody>
                </table>
                <!-- Product end -->
              </b-card>

              <!-- Totals -->
              <article class="card mb-2 rounded-0">
                <div class="card-body">
                  <table class="table animate__animated animate__bounce" v-if="currencyValue">
                    <tbody>
                      <h4 class="listPayTitle">Totals</h4>
                      <hr />
                      <tr class="text-small-cart row">
                        <span class="col-6" style="">
                          <span class="">Initial Payment:</span>
                          {{ formatCurrency(dataOrderPay.currencyFirstPayment) }} {{ dataOrderPay.currency }}
                        </span>
                        <span class="col-6"></span>
                      </tr>
                      <hr />
                      <tr class="text-small-cart row">
                        <span class="col-6">
                          <span style="font-weight: bold">Total Balance:</span>
                          {{ formatCurrency(dataOrderPay.currencyTotalSale) }} {{ dataOrderPay.currency }}
                        </span>
                        <span class="col-6">
                          <span style="font-weight: bold"> Paid out:</span>
                          {{ formatCurrency(dataOrderPay.currencyPaid) }} {{ dataOrderPay.currency }}
                        </span>
                      </tr>
                      <hr />
                      <tr class="total">
                        <span>
                          Current / Remaining Balance:
                          {{ formatCurrency(dataOrderPay.currencyBalance) }} {{ dataOrderPay.currency }}
                        </span>
                      </tr>
                    </tbody>
                  </table>

                  <div v-else class="text-center">
                    <b-spinner label="Loading..." variant="success" />
                  </div>
                </div>
              </article>

              <!-- Transactions -->
              <article class="card mb-2 rounded-0" v-if="dataOrderPay.currencyPaid != 0 && !isloadingTransactions">
                <div class="card-body">
                  <table class="table animate__animated animate__bounce">
                    <tbody>
                      <tr>
                        <h4 class="listPayTitle">Transactions</h4>
                        <div>
                          <table class="listPay">
                            <tr>
                              <th>Date</th>
                              <th>Num</th>
                              <th>Amount</th>
                              <!-- <th>Reference</th> -->
                              <th>Currency</th>
                              <th>Status</th>
                            </tr>
                            <tr v-for="listPay in listPayOrders" :key="listPay.id">
                              <td>{{ listPay.date }}</td>
                              <td>{{ listPay.card }}</td>
                              <td>{{ formatCurrency(listPay.amount) }}</td>
                              <!-- <td>{{listPay.folio_bank ? listPay.folio_bank : ""}}</td> -->
                              <td>{{ listPay.currency }}</td>
                              <td>{{ listPay.status }}</td>
                            </tr>
                          </table>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </article>

              <article class="card mb-2 rounded-0" v-else-if="isloadingTransactions">
                <div class="card-body text-center">
                  <b-spinner label="Loading..." variant="success" />
                </div>
              </article>

              <!-- ePayment -->
              <article class="card mb-2 rounded-0" v-if="isEpayment && formStatusCard && !isloadingTransactions">
                <div class="card-body">
                  <h4 class="listPayTitle">ePayment</h4>
                  <hr />
                  <b-row class="card-body">
                    <b-col md="8">
                      <span>This transaction was made by <i>ePayment</i></span>
                    </b-col>
                    <b-col md="4" v-if="!orderAlreadyPaid">
                      <b-button v-if="!showEditCardForm" class="text-center float-right" variant="primary" size="sm"
                        :disabled="isPayingBooking" @click="showEpaymentForm">
                        <feather-icon icon="CreditCardIcon" /> Edit card
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-card tag="article" class="mb-2 border rounded">
                    <b-row>
                      <b-col class="text-center">
                        <feather-icon size="30" icon="CreditCardIcon" />
                        <br />
                        <label>{{ dataOrderPay.tokenpayment.cardtype }}</label>
                      </b-col>
                      <b-col>
                        <div class="card-input text-center" style="margin-bottom: 1px">
                          <strong>Actual Card:</strong><br />
                          <label>
                            {{ dataOrderPay.tokenpayment.cardnumber }}
                          </label>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="card-input text-center" style="margin-bottom: 1px">
                          <strong>Holder:</strong><br />
                          <label>{{ dataOrderPay.tokenpayment.cardholdername || "N/A" }}</label>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </article>
            </div>

            <div v-else>
              <div class="alert alert-danger" role="alert">
                No information found
                <b-spinner small v-if="isValidate"></b-spinner>
              </div>
            </div>
          </b-col>

          <!-- 2da columna -->

          <!-- La orden ha sido cancelada -->
          <b-col md="6" sm="12" lg="6" xl="7" class="col-12" v-if="orderIsInvalid">
            <div>
              <PaymentResponse
                nbresponse = "Cancelado"
                :status = "dataOrderPay.orderStatusName"
                :importe = dataOrderPay.currencyPaid
                email = ""
              />
            </div>
          </b-col>

          <!-- Se debe generar enlace de pago -->
          <div class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 containerIframe"
            v-else-if="!!dataPaymentLink && !!dataPaymentLink.url && !manageEpayment && !orderAlreadyPaid && !internalIframeError">
            <iframe class="responsive-iframe" :src="dataPaymentLink.url">
            </iframe>
          </div>

          <!-- Hubo un error al generar enlace de pago -->
          <b-col class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 text-center h-100" align-self="center"
            v-else-if="!!dataPaymentLink && dataPaymentLink.error && !manageEpayment && !orderAlreadyPaid">
            <div align-v="center" class="w-100">
              <feather-icon icon="CreditCardIcon" size="6x" />
              <h4>Oops.</h4>
              <h6>Something happened here. Please try again later.</h6>
            </div>
          </b-col>

          <!-- Hubo un error en el enlace de pago -->
          <b-col class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 text-center h-100" align-self="center"
            v-else-if="internalIframeError">
            <div align-v="center" class="w-100">
              <feather-icon icon="CreditCardIcon" size="6x" />
              <h4>Something went wrong.</h4>
              <h6>An unexpected issue occurred. We were unable to process your transaction at this time. <br>
                Please try again later or contact support for assistance.</h6>
              <b-button variant="primary" class="mt-2" :disabled="loadvalid" @click="getLinkPay()">
                Retry payment <b-spinner small v-if="loadvalid" />
              </b-button>
            </div>
          </b-col>

          <!-- La orden ha sido pagada parcialmente -->
          <div class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7" v-else-if="dataOrderPay.currencyBalance != 0 && dataOrderPay.currencyPaid != 0 && !manageEpayment"> 
            <div class="checkout-options">
              <b-card>
                <h3>Pay outstanding balance</h3>
                <br />
                <div class="row">
                  <b-col class="col-6 col-md-6 col-sm-6">
                    <ValidationObserver tag="form" @submit.prevent="onSubmit" ref="observer">
                      <ValidationProvider rules="required" name="balance">
                        <b-input-group slot-scope="{ valid, errors }" prepend="Amount in USD">
                          <b-form-input type="number" step=".01" :placeholder="parseFloat(balancePaid).toFixed(2) + ' USD'
                            " :disabled="validPay" :state="errors[0] ? false : valid ? true : null" v-model="amount"
                            @input="validTotal()" locale="en">
                          </b-form-input>
                          <b-form-invalid-feedback>
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </ValidationProvider>
                    </ValidationObserver>
                  </b-col>
                  <b-col class="col-6 col-md-6 col-sm-6">
                    <validation-provider name="Divisa" rules="required">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-input-group prepend="Currency">
                          <b-form-select
                            id="divisaSelect"
                            @change="calcularImportes"
                            v-model="localCurrency"
                            :disabled="hasAcurrencyLock"
                            :state="errors[0] ? false : valid ? true : null"
                          >
                            <option v-for="cur in currencies" :key="cur.id" :value="cur">
                              {{ cur.code }}
                            </option>
                          </b-form-select>
                        </b-input-group>
                        <!-- <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback> -->
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </div>
                <!-- <hr> -->
                <div class="price-details">
                  <div v-if="currencyValue.code != 'USD'">
                    <hr />
                    <label class=""><span v-if="!validPay">Please set the amount to pay in <b>USD</b>.</span> Your payment will be displayed in <b>{{ currencyValue.code }}</b>.</label> <br>
                  </div>
                  <div v-if="localCurrency && localCurrency.code != 'USD'">
                    <div>
                      <hr />
                      <ul class="list-unstyled">
                        <li class="price-detail">
                          <div class="detail-title detail-total">
                            Exchange rate MXN:
                          </div>
                          <div class="detail-amt font-weight-bolder">
                            <b-badge pill>{{ tc }}</b-badge>
                          </div>
                        </li>
                        <li class="price-detail">
                          <div class="detail-title detail-total">
                            Total currency MXN:
                          </div>
                          <div class="detail-amt font-weight-bolder">
                            <b-badge pill>{{ totalDivisa }}</b-badge>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <hr />

                  <div class="float-right">
                    <div v-if="!loadvalid">
                      <b-button variant="primary" :disabled="validNull || loadvalid" @click="getLinkPay()">
                        <b-icon-check-square-fill></b-icon-check-square-fill>
                        Checkout
                      </b-button>
                    </div>
                    <div v-else class="text-center">
                      <b-spinner label="Loading..." variant="success" />
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>

          <!-- La orden ha sido pagada completamente y debe mostrar la "thank you page" -->
          <div class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 containerIframe"
           v-else-if="dataOrderPay.currencyPaid != 0 && dataOrderPay.currencyBalance == 0">
            <div class="checkout-options">
              <iframe class="responsive-iframe" :src="dataPaymentLink.url"> </iframe>
            </div>
          </div>

          <!-- La orden debe pagarse mediante E-payment -->
          <div class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7" v-else-if="isEpayment && !formStatusCard">
            <CardForm :form-data="formData" :FormStatus="waspaidwithtoken" @input-card-number="updateCardNumber"
              @input-card-name="updateCardName" @input-card-month="updateCardMonth" @input-card-year="updateCardYear"
              @input-card-cvv="updateCardCvv" @get-initial-content="setInitialData" />
          </div>

          <!-- Se actualizan los datos del E-payment -->
          <div class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7" v-else-if="manageEpayment">
            <CardFormEdit :form-data="formData" :FormStatus="waspaidwithtoken" :sum="dataOrderPay.currencyPaid"
              @input-card-number="updateCardNumber" @input-card-name="updateCardName"
              @input-card-month="updateCardMonth" @input-card-year="updateCardYear" @input-card-cvv="updateCardCvv"
              @get-initial-content="setInitialData" @cancel-epayment-form="hideEpaymentForm" />
          </div>

          <div v-else class="col-12 col-md-7 col-sm-12">
            <div class="checkout-options" v-if="validNull == false">
              <b-card>
                <div class="w-100 text-center">
                  <h2 class="mb-1">This order was not paid 🕵🏻‍♀️</h2>
                  <img src="/img/error.7cce96d0.svg" alt="Error page" class="img-fluid" />
                </div>
              </b-card>
            </div>
            <div v-else class="text-center loadingInitiate">
              <b-spinner label="Loading..." variant="success" />
            </div>
          </div>
        </b-row>

        <!-- Validador de email para acceder a la landing -->
        <b-col class="col-md-6 col-sm-12 col-lg-6 col-xl-5 columna mx-auto text-center"
          v-if="validPayResponse == false">
          <b-card>
            <b-col md="12">
              <ValidationProvider name="email" rules="required|email">
                <b-form-group label="Order Customer email*" slot-scope="{ valid, errors }">
                  <b-form-input class="form-control" type="email" v-model="email" autocomplete="off"
                    :state="errors[0] ? false : valid ? true : email != '' ? true : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] !== "" ? "Please enter a valid email" : "" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>

              <b-button variant="primary" :class="`text-center float-right ${currentBranding.buttonClass}`" :disabled="isValidate" size="sm"
                @click="setInitialData()">
                <b-spinner small v-if="isValidate" />
                Continue
              </b-button>
            </b-col>
          </b-card>
        </b-col>
      </b-container>
    </div>

    <footer :class="`p-footer ${currentBranding.footerClass}`">
      <div class="footer-1">
        <div class="text-center mt-half" style="font-weight: bold; color: white; font-weight: normal" id="">
          <span style="font-weight: normal">{{ currentBranding.copyright }}</span>
          <template v-if="currentBranding.address">
            <br />
            <span>{{ currentBranding.address }}</span>
          </template>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { toJson, showAlertMessage, toCurrency } from "@/helpers/helpers";
import { mapState, mapActions, mapMutations } from "vuex";
import HeaderPayment from "@/modules/shop/components/HeaderPayment"
import FooterPayment from "@/modules/shop/components/FooterPayment"
import CardForm from "@/modules/shop/components/landing/CardForm";
import PaymentResponse from "@/modules/shop/components/PaymentResponse"
import CardFormEdit from "@/modules/shop/components/landing/CardFormEdit";
import { paymentLinkBranding } from "@/data/data";
import { market } from '@/modules/shop/mixins/market'

export default {
  mixins: [market],
  components: {
    HeaderPayment,
    FooterPayment,
    CardForm,
    CardFormEdit,
    PaymentResponse
  },
  created(){
    this.currentBranding = this.publicLinksBranding()
  },
  async mounted() {
    if (this.order && this.email) {
      this.setInitialData();
    } else {
      this.validPayResponse = false;
      this.setDataOrder(null);
    }

    window.addEventListener("message", this.setInternalError);

  },
  data() {
    return {
      currentBranding: paymentLinkBranding.find(x=> x.brandingCode == "SC"),
      loadvalid: false,
      order: this.$route.query.order,
      urlbank: this.dataPaymentLink,
      sum: 0,
      amount: "",
      validNull: null,
      validPayResponse: false,
      currencyValue: 0,
      listPayOrders: [],
      balancePaid: 0.0,
      detailId: 0,
      isLoadingIframe: false,
      validPay: true,
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
      },
      labelTextValidEmail: "",
      email: null,
      waspaidwithtoken: false,
      showEditCardForm: false,
      isPayingBooking: false,
      isloadingTransactions: false,
      isValidate: false,
      internalIframeError: false,
      localCurrency: null
    };
  },
  computed: {
    ...mapState("shop", ["cart"]),
    ...mapState("start", ["currencies"]),
    ...mapState("shop", ["errorMessageApi", "dataOrderPay"]),
    ...mapState("mySales", [
      "errorMessageApi",
      "dataTransaction",
      "isloadingProcess",
      "dataPaymentLink",
      "transactionPay",
    ]),

    tc() {
      const currencieValor = this.localCurrency ? this.localCurrency.value : 1;
      return toCurrency(currencieValor)
    },
    totalDivisa() {
      const amount = Boolean(this.amount) ? parseFloat(this.amount) : 0;

      const currencieValor = this.localCurrency ? parseFloat(this.localCurrency.value).toFixed(2) : 1;
      return toCurrency(((parseFloat(amount) * parseFloat(currencieValor) * 100) / 100).toFixed(2));
    },
    formStatusCard() {
      const valid = this.dataOrderPay.tokenpayment ? true : false; // valida real
      // const valid = this.dataOrderPay.tokenpayment ? false : true
      this.waspaidwithtoken = valid;
      return valid;
    },
    isEpayment() {
      const validepayment = this.dataOrderPay?.isEpayment;
      const validpaymentmethod = this.dataOrderPay?.ePaymentMethod;
      const valid = validepayment == true && validpaymentmethod == true;
      return valid == true;
    },
    manageEpayment() {
      if (this.isEpayment) {
        if (this.waspaidwithtoken) if (!this.showEditCardForm) return false;
        return true;
      } else return false;
    },
    orderAlreadyPaid() {
      return (parseFloat(this.dataOrderPay?.balance) == 0.0);
    },
    hasAcurrencyLock(){
      return this.dataOrderPay?.currencyLocked || null
    },
    orderIsInvalid(){
      return [2, 10].includes(this.dataOrderPay?.orderStatus)
    },
  },
  methods: {
    ...mapActions("shop", ["fetchOrderPaymentData", "sendValidatePOS"]),
    ...mapActions("mySales", ["fetchDataurlBank"]),
    ...mapActions("mySales", ["fetchOrderTransactions"]),

    ...mapActions("mySales", ["fetchTransactionPay"]),
    ...mapActions("start", ["fetchCurrencies"]),

    ...mapMutations("shop", ["setDataOrder", "setCurrency"]),
    ...mapMutations("mySales", ["setDataTransaction"]),
    ...mapMutations("start", ["setCurrencies"]),

    async setInitialData() {
      const payload = {
        ref: this.order,
        email: this.email,
        type: 1,
      };

      this.isValidate = true;
      const validProcess = await this.sendValidatePOS(payload);

      if (validProcess == true) {
        const hasData = await this.getDataOrder();
        this.dataOrderPay.id = this.order
        if (!hasData) {
          this.isValidate = false;
          return showAlertMessage("Data validation", "InfoIcon", "No data found", "warning", 4000, "bottom-right");
        }
        this.validPayResponse = true;
        this.getTransactionsInfo();
        if (!this.currencies.length) {
          const currencies = await this.fetchCurrencies();
          this.setCurrencies(currencies); //muto state currencies en start
        }

        this.setCurrencyCustomer();
        const currency = this.dataOrderPay?.currencyLocked || this.dataOrderPay?.currency

        this.currencyValue = this.currencies.find((curr) => curr.code === currency);
        this.localCurrency = this.currencies.find((curr) => curr.code === currency);
      } else {
        this.labelTextValidEmail = "Customer email does not match";
        showAlertMessage("Email validation", "InfoIcon", this.labelTextValidEmail, "warning", 4000, "bottom-right");
        this.validPayResponse = false;
        this.setDataOrder(null);
      }

      this.isValidate = false;
    },
    setCurrencyCustomer() {
      const currency = this.dataOrderPay?.currencyLocked || this.dataOrderPay?.currency
      const divisa = toJson(
        this.currencies.find((curr) => curr.code === currency)
      );
      this.setCurrency(divisa);
    },
    setNullDataOrder() {
      this.setDataOrder(null);
    },
    async getDataOrder() {
      const response = await this.fetchOrderPaymentData({
        ref: this.order,
        email: this.email,
        type: 1,
      });
      if (!response) return false;
      this.isloadingTransactions = true;
      const transactions = await this.fetchOrderTransactions({ ref: this.order });
      this.setDataTransaction(transactions)
      this.isloadingTransactions = false;

      if (!this.orderIsInvalid) await this.fetchDataurlBank(this.order);
      return true;
    },
    getTransactionsInfo() {
      this.listPayOrders = [];
      this.listPayOrders = this.dataTransaction.filter((list) => list.status != "Pending")
      this.sum = this.dataTransaction.filter(list => list.status == "Approved").reduce((accum,item) => accum + item.amount, 0)

      if (this.dataOrderPay.currencyPaid != 0 && this.dataOrderPay.currencyBalance != 0) this.dataPaymentLink.url = "";
    },
    async getLinkPay() {
      const payload = {
        amount: this.amount,
        order: this.order,
        detail: this.detailId,
      };

      this.loadvalid = true;
      await this.fetchTransactionPay(payload);
      this.internalIframeError = false
      this.loadvalid = false;
      // this.urlbank = this.dataPaymentLink.url;
    },
    calcularImportes() {
      const currencieValor = this.localCurrency ? this.localCurrency.value : 1;
      this.divisaTotal = (Math.round(parseFloat(this.cart.totalBreakdown.total) * parseFloat(currencieValor) * 100) / 100).toFixed(2);
      this.setCurrency(this.localCurrency);
    },
    validTotal() {
      const total = parseFloat(this.amount);
      const balance = parseFloat(this.dataOrderPay.balance);
      if (total <= balance) this.validNull = false;
      else this.validNull = true;
    },
    sendPayBook(item) {
      if (!!item?.booking?.id && !!item?.partial && parseFloat(this.dataOrderPay.totalPaid) != 0) {
        this.internalIframeError = false
        this.isPayingBooking = true;
        this.balancePaid = parseFloat(item.balance);
        this.detailId = item.ref;
        this.validPay = false;
        this.validNull = false;
        this.amount = parseFloat(item.balance);
      }
    },
    cancelPayBook(item) {
      this.isPayingBooking = false;
      this.balancePaid = 0.0;
      this.detailId = 0;
      this.validPay = true;
      this.validNull = null;
      this.amount = "";
      this.dataPaymentLink.url = ""
    },
    // paycard
    updateCardNumber(val) { },
    updateCardName(val) { },
    updateCardMonth(val) { },
    updateCardYear(val) { },
    updateCardCvv(val) { },
    showEpaymentForm() {
      this.showEditCardForm = true;
    },
    hideEpaymentForm() {
      this.showEditCardForm = false;
    },
		formatCurrency(amount) {
			return toCurrency(amount)
		},
    setInternalError(event){
      if (event.data.hasOwnProperty('success') && event.data.hasOwnProperty('session') && (!event.data.session || event.data.success == 'false')) {
        this.internalIframeError = true
      }
    }
  },
};
</script>

<style scoped>
.main-page {
  overflow-x: hidden;
  min-height: 100vh;
  /* Asegura que el contenedor tenga al menos la altura del viewport */
}

.p-container {
  max-width: 968px;
  margin-left: 1rem;
  margin-right: 1rem;
}

.p-header {
  width: 100%;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 100;
  text-align: center;
  /* Alinea el contenido al centro horizontalmente */
  padding: 1rem;
}

.bg-header-one {
  background-color: #000000;
}

.bg-header-two {
  background-color: #ffffff;
}

.bg-header-three {
  background-color: #13748C;
}
.p-container .nav {
  text-align: center;
  /* Alinea el contenido al centro horizontalmente */
}

.p-header nav {
  height: 7rem;
  text-align: center;
}

.nav-logo {
  margin: 0 auto;
  /* Centra el contenedor horizontalmente */
  display: flex;
  justify-content: center;
  /* Alinea el contenido del contenedor al centro horizontalmente */
  align-items: center;
  /* Alinea el contenido del contenedor al centro verticalmente */
}

.nav-logo img {
  width: 200px;
}

.button-epic{
  background-color: #00748D !important;
  border-color: #00748D !important;
}

.button-mhtn{
  background-color: #4cb8c4 !important;
  border-color: #4cb8c4 !important;
}

.body-page {
  /* margin-top: 10rem;  */
  /* height: 100vh; */
  margin-bottom: 3rem;
}

.content-page {
  margin: 0 auto;
  /* Centra el contenedor horizontalmente */
  padding: 1rem;
}

.p-footer {
  background-color: #000000;
  color: white;
  /* text-align: center; */
  padding: 10px;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 0.5rem;
  z-index: 1000;
}

.p-footer-bg-one {
  background-color: #000000;
}

.p-footer-bg-two {
  background-color: #45c3bb;
}

.p-footer-bg-three {
  background-color: #585857 !important;
}

.footer-1 {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-1 img {
  width: 250px;
}

p a {
  color: #ffffff;
}

/* Rest css */
iframe {
  overflow: hidden;
}

.containerIframe {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 619px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.fixed-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 40%;
  border: none;
}

.alert.alert-danger {
  padding: 9px 0 7px 13px;
}

.container-xl,
.container-lg,
.container-md,
.container-sm,
.container {
  max-width: 1440px;
}

.container {
  padding-bottom: 62px;
}

#app>div {
  display: inline-table;
}

tr.total {
  text-align: center;
  padding: 14px 0 0 0;
  display: block;
  font-weight: 600;
  font-size: 18px;
}

tr.text-small-cart.row {
  text-align: center;
}

tr.listPay {
  text-align: center;
  font-size: 12px;
}

.listPay th,
.listPay td {
  padding: 8px;
  font-size: 12px;
  vertical-align: middle;
}

.listPayTitle {
  text-align: center;
  margin-bottom: 10px;
}

ul.list-unstyled {
  text-align: right;
}

table.content.booking {
  margin: 12px 0 0 0;
}

table.content.booking span {
  padding-right: 5px;
}

table.content.booking tr,
table.content.booking td {
  border: 0;
  padding: 6px 15px 6px 15px;
}

.titleProduc {
  font-weight: bold;
  margin: 3px 0 10px 0;
  display: block;
}

table.listPay {
  margin: 0 auto;
}

.bg-gradient-success,
.btn-gradient-success {
  color: #fff;
  transition: all 0.2s ease;
  background-image: linear-gradient(47deg, #339e62, #1f8a4e);
  background-repeat: repeat-x;
  background-repeat: repeat;
}

.loadingInitiate {
  margin: 20px 0 0 0;
}

@media (max-width: 1380px) {

  .listPay th,
  .listPay td {
    padding: 5px;
    font-size: 10px;
    vertical-align: middle;
  }
}

footer.navbar-dark {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1;
}
</style>
<style scoped src="@/assets/css/success.css"></style>
